import * as React from 'react';
import styles from './Eyebrow.module.css';

export interface EyebrowProps {
  children?: React.ReactNode;
}
export const Eyebrow = ({ children }: EyebrowProps) => {
  return <div className={styles.Eyebrow}>{children}</div>;
};
